import React from "react";
import TextOrVideo from "./TextOrVideo";

export default function InsamlingsInstruktioner() {
    return (
        <div>
            <TextOrVideo
                title={"Om testningen"}
                body={
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laboru"
                }
                video={"https://vimeo.com/587461129/8b4b05be6f"}
            />
        </div>
    );
}
